import { useEffect } from "react";
import Contracts from "../../../Components/PaymentLedger/Contracts/Contracts";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Page_Contract = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const adminWalletId = params.get("walletId");
  const entityType = params.get("entityType");

  const wallet = useSelector(
    (state) => state?.paymentSlice?.walletAccountActive,
  );

  // Only redirect when visited directly (not from WalletTable admin flow)
  useEffect(() => {
    if (!adminWalletId && !wallet?.id) {
      navigate(-1);
    }
  }, [adminWalletId, wallet?.id, navigate]);

  return (
    <Contracts
      walletId={adminWalletId || wallet?.id}
      entityType={entityType}
    />
  );
};

export default Page_Contract;
